import { FunctionComponent, ReactElement } from "react";

import { InputAdornment, TextField } from "@mui/material";

import { Info } from "@mui/icons-material";

import { FormikErrors, FormikTouched } from "formik";

import { Paper } from "../../../components/common";

import {
    FreebieRuleSection,
    IFreebieRuleForm,
    Row,
    SectionTitle,
    StyledTooltip,
    TextFieldContainer,
    disableScrollWheelInput,
} from "./common";

export interface ICheckpointSectionProps {
    values: IFreebieRuleForm;
    touched: FormikTouched<IFreebieRuleForm>;
    errors: FormikErrors<IFreebieRuleForm>;
    onChange: (e: React.ChangeEvent<any>) => void;
    onBlur: {
        (e: React.FocusEvent<any, Element>): void;
        <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void;
    };
}

export const CheckpointSection: FunctionComponent<ICheckpointSectionProps> = (
    props: ICheckpointSectionProps,
): ReactElement => {
    const { values, errors, touched, onChange, onBlur } = props;
    return (
        <Paper>
            <FreebieRuleSection>
                <SectionTitle>Minimum cart value</SectionTitle>
                <Row>
                    <TextFieldContainer>
                        <TextField
                            type="number"
                            fullWidth={true}
                            required={true}
                            name="minCartValue"
                            value={values.minCartValue}
                            onChange={onChange}
                            label="Minimum cart value"
                            size="small"
                            variant="outlined"
                            onBlur={onBlur}
                            onWheel={disableScrollWheelInput}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        ₹
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <StyledTooltip
                                            enterTouchDelay={0}
                                            placement="top"
                                            title="The cart's non-freebie selling price must reach this value for the freebie to be granted."
                                        >
                                            <Info
                                                htmlColor="#626262"
                                                fontSize="small"
                                            />
                                        </StyledTooltip>
                                    </InputAdornment>
                                ),
                            }}
                            error={
                                Boolean(errors.minCartValue) &&
                                touched.minCartValue
                            }
                            helperText={
                                touched.minCartValue && errors.minCartValue
                            }
                        />
                    </TextFieldContainer>
                    <TextFieldContainer>
                        <TextField
                            fullWidth={true}
                            name="discountCode"
                            value={values.discountCode}
                            onChange={onChange}
                            label="Discount code (optional)"
                            size="small"
                            variant="outlined"
                            onBlur={onBlur}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <StyledTooltip
                                            enterTouchDelay={0}
                                            placement="top"
                                            title="If set, the freebie is also granted when this discount code is applied, regardless of cart value."
                                        >
                                            <Info
                                                htmlColor="#626262"
                                                fontSize="small"
                                            />
                                        </StyledTooltip>
                                    </InputAdornment>
                                ),
                            }}
                            error={
                                Boolean(errors.discountCode) &&
                                touched.discountCode
                            }
                            helperText={
                                touched.discountCode && errors.discountCode
                            }
                        />
                    </TextFieldContainer>
                </Row>
            </FreebieRuleSection>
        </Paper>
    );
};
